export default __webpack_public_path__ + "static/media/syncing-done.b88b1f76.svg";